import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    UserCircleIcon,
    ArrowRightEndOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { Settings } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'components/shadcn/ui/dropdown-menu';
import { Switch } from 'components/shadcn/ui/switch';
import { Button } from 'components/shadcn/ui/button';
import { useAppController, setMiniSidenav } from 'context';
import ThemeToggle from './ThemeToggle';

const HGOptions = () => {
    const navigate = useNavigate();
    const [controller, dispatch] = useAppController();
    const { miniSidenav } = controller;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1280);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleProfile = () => {
        navigate('/profile');
    };

    const handleLogout = () => {
        navigate('/logout');
    };

    const handleToggleSidebar = () => {
        setMiniSidenav(dispatch, !miniSidenav);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    aria-label="Settings"
                    className="h-auto w-auto p-2 transition-colors [&_svg]:size-5 xl:w-full xl:justify-start xl:gap-3 xl:rounded-lg xl:px-3 xl:py-3"
                >
                    <Settings className="shrink-0" />
                    {!miniSidenav && (
                        <span className="hidden text-sm capitalize xl:inline">
                            Settings
                        </span>
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                side={isMobile ? 'bottom' : 'right'}
                align="end"
                sideOffset={5}
            >
                <DropdownMenuItem
                    onClick={handleToggleSidebar}
                    onSelect={(e) => e.preventDefault()}
                    className="hidden xl:flex"
                >
                    <Switch
                        id="mini-sidebar"
                        checked={miniSidenav}
                        onCheckedChange={handleToggleSidebar}
                    />
                    <span>Mini Sidebar</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="cursor-default gap-3 hover:bg-transparent focus:bg-transparent focus:text-card-foreground"
                    onSelect={(e) => e.preventDefault()}
                >
                    <ThemeToggle />
                    <span>Theme</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={handleProfile}>
                    <UserCircleIcon className="mr-2 h-4 w-4" />
                    <span>Profile</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={handleLogout}>
                    <ArrowRightEndOnRectangleIcon className="mr-2 h-4 w-4" />
                    <span>Logout</span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default HGOptions;
